import React, { useContext, useState, useRef, useEffect } from 'react'
import ReactCountryFlag from "react-country-flag"
import { NavLink } from 'react-router-dom'
import { AiFillHome } from 'react-icons/ai'
import { MdOutlineFavorite } from 'react-icons/md'
import { GiHockey } from 'react-icons/gi'
import { FaHockeyPuck } from 'react-icons/fa'
import { FiSettings } from 'react-icons/fi'
import NhlGamesContext from './context/Context'
import ThemeSelector from './ThemeSelector'
import './Nav.css'

function NavMenu() {
  const { toggle, setToggle, setWantfins, setWantswedes, wantfins, wantswedes } = useContext(NhlGamesContext)
  const [settingsOpen, setSettingsOpen] = useState(false)
  const settingsRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setSettingsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <header className="navbar">
      <div className="nav-inner">
        <NavLink to="/" end className="brand" aria-label="NHL Recap — home">
          <span className="brand-mark">NHL</span>
          <span className="brand-text">Recap</span>
        </NavLink>

        <nav className="site-links" aria-label="Primary">
          <NavLink to="/" end className="nav-link" aria-label="Home">
            <AiFillHome />
          </NavLink>
          <NavLink to="/favs" className="nav-link" aria-label="Favorites">
            <MdOutlineFavorite />
          </NavLink>
          <NavLink to="/teams" className="nav-link" aria-label="Teams">
            <GiHockey />
          </NavLink>
        </nav>

        <div className="nav-controls">
          <button
            type="button"
            className={`score-toggle ${toggle ? 'on' : ''}`}
            onClick={() => setToggle(!toggle)}
            aria-pressed={toggle}
            aria-label={toggle ? 'Hide scores' : 'Show scores'}
            title={toggle ? 'Scores: on' : 'Scores: off'}
          >
            <FaHockeyPuck />
          </button>

          <div className="nav-settings" ref={settingsRef}>
            <button
              type="button"
              className={`settings-trigger ${settingsOpen ? 'open' : ''}`}
              onClick={() => setSettingsOpen((o) => !o)}
              aria-label="Settings"
              aria-expanded={settingsOpen}
            >
              <FiSettings />
            </button>

            {settingsOpen && (
              <div className="settings-popover" role="menu">
                <div className="setting-row">
                  <span className="setting-label">
                    <ReactCountryFlag countryCode="FI" svg className="setting-flag" />
                    Finns
                  </span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={wantfins}
                      onChange={() => setWantfins(!wantfins)}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>

                <div className="setting-row">
                  <span className="setting-label">
                    <ReactCountryFlag countryCode="SE" svg className="setting-flag" />
                    Swedes
                  </span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={wantswedes}
                      onChange={() => setWantswedes(!wantswedes)}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>

                <div className="setting-divider" />

                <div className="setting-row setting-row-theme">
                  <span className="setting-label">Theme</span>
                  <ThemeSelector />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default NavMenu
